import _ from 'lodash';
import { Tooltip } from '@material-ui/core';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import {
  RepositoriesModalBoxes,
  Footer
} from './repositories-modal.components';
import {
  inviteYourAdmin,
  findAndDeleteSensor
} from './repositories-modal.service';
import InfoBox from 'components/InfoBox';
import { pluralize } from 'common/utils/utils';
import { LBButton } from '@linearb/buzz';

const RepositoriesModalFooter = ({
  isOnboarding,
  gitIntegrations,
  sensor_authorization_id,
  deleteSensorAuthorization,
  toggleSnackBar,
  account,
  selectedReposMessage,
  selected,
  numOfSelectableRepos,
  saving,
  onSubmit,
  isTeamLicense,
  license,
  isConnectGitStreamFlow
}) => (
  <Footer isOnboarding={isOnboarding} direction='column'>
    <InfoBox mt={null} mb='medium' direction='row' items='center'>
      <Flex items='center'>
        <Text size='medium' weight='bold'>
          {selectedReposMessage}.
        </Text>
        <Text size='medium' ml='0.5rem'>
          {isTeamLicense ? 'Our free' : 'Your'} plan is limited to{' '}
          {pluralize(_.get(license, 'maxRepos', numOfSelectableRepos), 'repo')}
        </Text>
      </Flex>
    </InfoBox>
    <Flex>
      <Flex grow='1' items='center'>
        {isOnboarding && (
          <Tooltip
            interactive
            placement='top'
            title={
              <Padding t='small' b='small'>
                <RepositoriesModalBoxes
                  accessTokenCb={() =>
                    findAndDeleteSensor({
                      isOnboarding,
                      gitIntegrations,
                      sensor_authorization_id,
                      deleteSensorAuthorization
                    })
                  }
                  inviteYourAdminCb={() =>
                    inviteYourAdmin(toggleSnackBar, account)
                  }
                />
              </Padding>
            }
          >
            <LBButton variant='outline' size='sm'>
              <Icon size='x-small' name='helpicon' color='pigeonPost' />
              Can't find any team repositories?
            </LBButton>
          </Tooltip>
        )}
      </Flex>
      <Flex items='center' justify='end'>
        <LBButton
          data-cy='continue'
          disabled={
            !selected.size || selected.size > numOfSelectableRepos || saving
          }
          onClick={() => onSubmit()}
        >
          {isConnectGitStreamFlow ? 'Finish' : 'Save Repositories'}
        </LBButton>
      </Flex>
    </Flex>
  </Footer>
);

export default RepositoriesModalFooter;
